import { ITimeEntryDay } from '../queries/TimeEntry';
import { formatHours } from './hours';

export function lockedDayMessage(data: ITimeEntryDay, approvedDetail = '') {
	const { entry, block } = data;
	if (entry?.status === 'Approved') {
		return `${formatHours(entry.hours)} hours, approved${approvedDetail}. Approved days are locked. Ask an admin to reopen it if something needs to change.`;
	}
	if (!entry && block === 'Weekend') {
		return 'Weekends are blocked. If you worked, ask an admin to open the day so you can enter hours.';
	}
	if (!entry && block === 'Holiday') {
		return 'This day is a holiday. If you worked, ask an admin to open the day so you can enter hours.';
	}
	return 'This day can’t be edited right now.';
}
